import React from 'react';
import { Chip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';

import { FDataGrid, FGrid, FGridMoneyCell } from '../grid';
import { IActivityBudgetRegister } from './budgetallocation.models';

type Props = {
  rows: IActivityBudgetRegister[];
  loading?: boolean;
};

const stateColor = (code?: string): any => {
  switch (String(code || '').toUpperCase()) {
    case 'BUDGETED':
      return 'success';
    case 'VARIANCE_UP':
      return 'warning';
    case 'VARIANCE_DOWN':
      return 'info';
    case 'PARTIAL':
      return 'warning';
    case 'PENDING':
      return 'default';
    default:
      return 'default';
  }
};

class ActivityBudgetRegisterGrid extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'activitycode', headerName: 'Activity', width: 145 },
    { field: 'activityname', headerName: 'Activity Plan', flex: 1, minWidth: 300 },
    { field: 'costcentercode', headerName: 'CC', width: 100 },
    { field: 'plannedamount', headerName: 'Planned', width: 135, renderCell: FGridMoneyCell },
    { field: 'financialisedamount', headerName: 'Financialised', width: 145, renderCell: FGridMoneyCell },
    { field: 'varianceamount', headerName: 'Variance', width: 135, renderCell: FGridMoneyCell },
    {
      field: 'variancepercent',
      headerName: 'Variance %',
      width: 110,
      renderCell: (params: any) =>
        params.value === null || params.value === undefined
          ? '—'
          : `${Number(params.value).toLocaleString('fr-FR', { maximumFractionDigits: 2 })}%`,
    },
    { field: 'allocationcount', headerName: 'Links', width: 80, type: 'number' },
    {
      field: 'linkingstatecode',
      headerName: 'Financialisation',
      width: 165,
      renderCell: (params: any) => (
        <Chip
          size="small"
          label={params.row.linkingstatename || params.value || 'PENDING'}
          color={stateColor(params.value)}
        />
      ),
    },
    {
      field: 'submitready',
      headerName: 'Ready',
      width: 100,
      renderCell: (params: any) => (
        <Chip
          size="small"
          variant="outlined"
          color={params.value ? 'success' : 'default'}
          label={params.value ? 'READY' : 'PENDING'}
        />
      ),
    },
  ];

  render() {
    return (
      <FDataGrid
        title="Activity Budget Register"
        subtitle="Cycle-wide financialisation register. Cost Centre selection filters this register and opens the allocation workspace."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={440}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#f5f7fa' }}
        getRowId={(row: any) => row.activityplanid || row.recid}
        pageSizeOptions={[10, 25, 50, 100]}
        initialState={{
          pagination: { paginationModel: { pageSize: 10 } },
        }}
      />
    );
  }
}

export default ActivityBudgetRegisterGrid;
